import script from "./BarcodeGenerator.vue?vue&type=script&lang=js"
export * from "./BarcodeGenerator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/views/orders/BarcodeGenerator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70ef9893"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70ef9893', __exports__)) {
    console.log('reload')
    api.reload('70ef9893', __exports__)
  }
  
}


export default __exports__